import { useAtom } from 'jotai';
import { editAnnotationCallbackAtom } from '../atoms';
export const useEditAnnotationHandlers = (canEdit: boolean) => {
  const [editAnnotationCallback, setEditAnnotationCallback] = useAtom(editAnnotationCallbackAtom);
  return {
    ...(canEdit && editAnnotationCallback),
    setEditAnnotationCallback
  };
};